<rx-banner-dismissible type="warning" data-testid="missing-case-assets-banner" [autoDismiss]="false" (dismissed)="dismissed.emit()">
	<div class="rx-intuitive-missing-attachments-banner__content">
		<span class="rx-intuitive-missing-attachments-banner__message">
			<tlk-no-image-icon class="tlk-icon_size_l" aria-hidden="true"></tlk-no-image-icon>
			<span>{{ 'ArtTreatments.ART.Assets.MissingCaseAssets' | translate }}</span>
		</span>
		<a class="rx-intuitive-missing-attachments-banner__link" href="#attachments-section" (click)="scrollToAttachments($event)">
			<tlk-arrow-down-icon class="tlk-icon_size_m" aria-hidden="true"></tlk-arrow-down-icon>
			{{ 'ArtTreatments.ART.Assets.GoToAttachments' | translate }}
		</a>
	</div>
</rx-banner-dismissible>
